const PropTypes = require('prop-types');
const React = require('react');
const ProductSearchForm = require('../../../product_search_form/product_search_form');
const APIRequest = require('../../../api_request');
const OfferItemView = require('./offer_item_view');
const NegotiationSubtotal = require('./negotiation_subtotal');
const BuyerDetails = require('./buyer_details');
const OfferItems = require('./offer_items');
const TextareaAutosize = require('react-autosize-textarea').default;

class EmailOfferForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offerItems: new OfferItems([], this.props.listingCurrency),
      productSearchInputValue: '',
      buyer: {},
      message: '',
      isLoading: false,
      errorMessage: '',
    };

    this.addOfferItem = this.addOfferItem.bind(this);
    this.removeOfferItem = this.removeOfferItem.bind(this);
    this.setOfferItemPrice = this.setOfferItemPrice.bind(this);
    this.setOfferItemShippingPrice = this.setOfferItemShippingPrice.bind(this);
    this.setBuyerDetails = this.setBuyerDetails.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.handleProductSearchFormChange = this.handleProductSearchFormChange.bind(this);
    this.createEmailOffer = this.createEmailOffer.bind(this);
    this.handleCreateEmailOfferResponse = this.handleCreateEmailOfferResponse.bind(this);
    this.handleCreateEmailOfferError = this.handleCreateEmailOfferError.bind(this);
  }

  setMessage(e) {
    this.setState({ message: e.target.value });
  }

  setBuyerDetails(buyerDetails) {
    const buyer = Object.assign({}, this.state.buyer, buyerDetails);
    this.setState({ buyer });
  }

  setOfferItemPrice(args) {
    const offerItems = this.state.offerItems.clone;
    offerItems.setPrice(args);
    this.setState({ offerItems });
  }

  setOfferItemShippingPrice(args) {
    const offerItems = this.state.offerItems.clone;
    offerItems.setShippingPrice(args);
    this.setState({ offerItems });
  }

  handleCreateEmailOfferResponse(response) {
    if (response.success) {
      this.window.location.href = this.props.offerCreatedPath;
    } else {
      this.setState({
        isLoading: false,
        errorMessage: response.error_message,
      });
    }
  }

  handleCreateEmailOfferError() {
    this.setState({
      isLoading: false,
      errorMessage: I18n.t('emailOffers.offerCreationFailed'),
    });
  }

  get window() {
    return this.props.window || window;
  }

  get emailOfferParams() {
    return JSON.stringify({
      buyer: {
        first_name: this.state.buyer.firstName,
        last_name: this.state.buyer.lastName,
        email: this.state.buyer.email,
        accepts_email_marketing: this.state.buyer.acceptsEmailMarketing,
      },
      offer_items: this.state.offerItems.offerItems.map(offerItem => ({
        listing_id: offerItem.listingId,
        price: offerItem.price,
        shipping_price: offerItem.shippingPrice,
      })),
      message: this.state.message,
      expected_subtotal: this.state.offerItems.subtotal.toString(),
    });
  }

  createEmailOffer(e) {
    e.preventDefault();

    this.setState({ isLoading: true });

    APIRequest.post(
      this.props.emailOffersPath,
      this.emailOfferParams,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(this.handleCreateEmailOfferResponse).fail(this.handleCreateEmailOfferError);
  }

  removeOfferItem(listingId) {
    const offerItems = this.state.offerItems.clone;
    offerItems.remove(listingId);
    this.setState({ offerItems });
  }

  addOfferItem(listing) {
    const offerItems = this.state.offerItems.clone;
    offerItems.add(listing);
    this.setState({
      offerItems,
      productSearchInputValue: '',
    });
  }

  handleProductSearchFormChange(e) {
    this.setState({ productSearchInputValue: e.target.value });
  }

  get emailOfferTitle() {
    if (!this.state.buyer.firstName || !this.state.buyer.lastName) {
      return I18n.t('emailOffers.buyerDetails.emailOffer');
    }

    return I18n.t('emailOffers.buyerDetails.emailOfferWithBuyerName', {
      buyerName: `${this.state.buyer.firstName} ${this.state.buyer.lastName}`,
    });
  }

  renderProductSearchForm() {
    return (
      <ProductSearchForm
        productSelected={this.addOfferItem}
        currentListingIds={this.state.offerItems.listingIds}
        onChange={this.handleProductSearchFormChange}
        inputValue={this.state.productSearchInputValue}
      />
    );
  }

  renderOfferItems() {
    return this.state.offerItems.offerItems.map((offerItem, index) =>
      <div key={index} className="email-offer__item">
        <OfferItemView
          offerItem={offerItem}
          onRemove={this.removeOfferItem}
          setPrice={this.setOfferItemPrice}
          setShippingPrice={this.setOfferItemShippingPrice}
        />
      </div>
    );
  }

  renderTextarea() {
    return (
      <TextareaAutosize
        rows={3}
        className="wide"
        name="negotiation[message]"
        value={this.state.message}
        onChange={this.setMessage}
      />
    );
  }

  renderAlert() {
    if (this.state.errorMessage) {
      return <div className="alert alert-error">{this.state.errorMessage}</div>;
    }

    return false;
  }

  render() {
    return (
      <form>
        <div className="g-container">
          <div className="g-col-8 g-col-mobile-12">
            {this.renderAlert()}

            <div className="shadowed">
              <div className="module-header">
                <h3 className="heading-3">{I18n.t('emailOffers.buyerDetails.title')}</h3>
              </div>
              <div className="module">
                <BuyerDetails
                  buyer={this.state.buyer}
                  onChange={this.setBuyerDetails}
                />
                <div className="email-offer">
                  <h3 className="email-offer__title">
                    {this.emailOfferTitle}
                  </h3>
                  <div className="email-offer__items">
                    {this.renderOfferItems()}
                  </div>
                  <div className="email-offer__search">
                    <label className="email-offer__search-label">
                      {I18n.t('emailOffers.productSearchForm.addListings')}
                    </label>
                    {this.renderProductSearchForm()}
                  </div>
                  <div className="email-offer__totals">
                    <NegotiationSubtotal offerItems={this.state.offerItems} />
                  </div>
                  <div className="email-offer__message">
                    <label>
                      {I18n.t('emailOffers.writeAMessage')}
                    </label>
                    {this.renderTextarea()}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <button
                onClick={this.createEmailOffer}
                className="button button--orange"
                disabled={this.state.isLoading}
              >
                {I18n.t('emailOffers.sendOffer')}
              </button>
            </div>
          </div>
          <div className="g-col-4 c-col-mobile-12">
            <h3 className="heading-3 mb-half">
              {I18n.t('emailOffers.explanation.title')}
            </h3>
            <p className="mb-0">
              {I18n.t('emailOffers.explanation.summary')}
            </p>
          </div>
        </div>
      </form>
    );
  }
}

EmailOfferForm.propTypes = {
  emailOffersPath: PropTypes.string.isRequired,
  offerCreatedPath: PropTypes.string.isRequired,
  listingCurrency: PropTypes.string.isRequired,
  initialListingId: PropTypes.string,
  window: PropTypes.object,
};

module.exports = EmailOfferForm;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/email_offer_form.jsx